import { Component, OnInit, OnDestroy, AfterViewInit, QueryList, ViewChildren, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpRepositoryService } from '../../../core/http-repository.service';
import { ContactListContacts, ContactListContactModel, ContactListContact, CustomFieldJson } from './contact-list-contacts.model';
import { ContactListContactsEditComponent } from '../contact-list-contacts-edit/contact-list-contacts-edit.component';
import { Location } from '@angular/common';
import { MessageDialogComponent } from '../../../core/message-dialog/message-dialog.component';
import { MessageType } from '../../../core/message-dialog/message-type.enum';
import { Title } from '@angular/platform-browser';
import { map } from 'rxjs/operators';
import { AntiForgeryTokenService } from '../../../auth/anti-forgery-token.service';
import { SubSink } from 'subsink';
import { UserCompanyService } from '../../../nav-menu/user-company.service';

declare var $: any;
declare var Toast: any;

@Component({
  selector: 'contact-list-contacts',
  templateUrl: './contact-list-contacts.component.html',
  styleUrls: ['./contact-list-contacts.component.css']
})

export class ContactListContactsComponent implements OnInit, AfterViewInit, OnDestroy {

  private id: number;
  private dataTable: any;
  private dtTable: any;
  private dtOptions: any;
  private contactListContacts: ContactListContacts = new ContactListContacts(0, null, [], []);
  private navbarHeadline: any;
  private selectedCompany: number;
  private selectCompanyHtmlElement: any;
  private subs = new SubSink();

  @ViewChildren('contactCustomFieldValues') contactCustomFieldValues: QueryList<any>;
  @ViewChild('editModal', { static: false }) editModal: ContactListContactsEditComponent
  @ViewChild('msgDialog', { static: false }) msgDialog: MessageDialogComponent;

  constructor(private route: ActivatedRoute, private repository: HttpRepositoryService,
    private location: Location, private router: Router, private titleService: Title,
    private antiForgery: AntiForgeryTokenService,
    private companyService: UserCompanyService) { }

  ngOnInit() {
    this.subs.sink = this.companyService.currentSelectedCompanyCode.subscribe(resp => {
      this.titleService.setTitle("Link.Maketer - " + resp);
    });

    this.id = parseInt(this.route.snapshot.paramMap.get('id'));
    this.dataTable = $('#contactListContactsTable');
    this.navbarHeadline = $('#navbarHeadline');
    this.selectCompanyHtmlElement = $('#selectCompanyDropdown');

    this.subs.sink = this.companyService.currentSelectedCompany.subscribe(cmpResp => {
      this.selectedCompany = cmpResp;
      this.loadData();
    });
  }

  ngAfterViewInit() {
    this.contactCustomFieldValues.changes.subscribe(resp => {
      if (!this.dtTable) {
        this.createDataTable();
      }
    });
  }

  private createDataTable() {
    var that = this;

    this.dtOptions = {
      columns: [
        {
          name: 'idcontactcontactlist',
          visible: false
        },
        {
          name: 'id',
          visible: false
        },
        {
          name: 'email'
        },
        {
          name: 'phone'
        }
      ],
      orderBy: [[1, 'asc']],
      rowButtons: {
        header: 'Options',
        dropdown: {
          text: '<i class="fas fa-ellipsis-v"></i>',
          class: '',
        },
        buttons: [{
          text: '<i class="fas fa-edit pr-3"></i> Edit',
          class: 'editrow',
          dataAttributes: ['id'],
          action: function (id) {
            that.edit(id);
          }
        },
        {
          text: '<i class="fas fa-user-times"></i> Unsubscribe',
          class: 'unsubscriberow',
          dataAttributes: ['idcontactcontactlist'],
          action: function (id) {
            that.unsubscribe(id);
          }
        },
        {
          text: '<i class="fas fa-trash pr-3"></i> Remove',
          class: 'deleterow',
          dataAttributes: ['idcontactcontactlist'],
          action: function (id) {
            that.delete(id);
          }
        }]
      },
      buttons: [{
        text: '<i class="fas fa-arrow-left"></i>',
        class: '',
        action: function () {
          that.goBack()
        }
      },
      {
        text: '<i class="fas fa-plus"></i>',
        class: '',
        action: function () {
          that.create()
        }
      },
      {
        text: '<i class="fas fa-trash-alt"></i>',
        class: '',
        action: function () {
          that.deleteList()
        }
      },
      {
        text: '<i class="fas fa-user-slash"></i>',
        class: '',
        action: function () {
          that.viewUnsubscribesContacts();
        }
      },
      {
        text: '<i class="fas fa-user-minus"></i>',
        class: '',
        action: function () {
          that.listUnsubscribe()
        }
      }]
    }

    this.contactListContacts.customFields.forEach(function (item) {
      if (item.type == 'logical') {
        that.dtOptions.columns.push({
          name: item.name,
          class: 'text-center',
          filterable: false,
          width: '100px',
          renderBoolAsCheckbox: true,
          boolTrueValue: 'true',
          boolFalseValue: 'false',
          useFalseIcon: true
        });
      } else {
        that.dtOptions.columns.push({ name: item.name })
      }
    });

    this.dtTable = this.dataTable.LinkTable(this.dtOptions);
  }

  private loadData() {
    var that = this;
    this.selectCompanyHtmlElement.addClass('disabled');

    if (this.selectedCompany == 0)
      this.router.navigate(['/notfound']);

    this.subs.sink = this.repository.get<ContactListContacts>('api/ContactList/Contacts/' + this.id + '?companyId=' + this.selectedCompany).pipe(map(x => x.data)).subscribe(resp => {
      this.contactListContacts = resp;

      this.navbarHeadline.html(this.contactListContacts.name + ' - Contacts');

      this.contactListContacts.contacts.forEach(function (contact) {
        contact.customFieldsJson = that.updateCustomFields(that.contactListContacts.customFields, contact.customFieldsJson);
      });

      if (this.contactListContacts.contacts.length == 0 && this.contactListContacts.customFields.length == 0) {
        if (!this.dtTable) {
          this.createDataTable();
        }
      }
    });
  }

  private goBack() {
    this.location.back();
    this.selectCompanyHtmlElement.removeClass('disabled');
  }

  private create() {
    let data = new ContactListContactModel(this.id, 0, 0, null, null, this.contactListContacts.customFields);
    this.editModal.show(data, true);
  }

  private edit(id) {
    let query = btoa(encodeURI(this.id + '&' + id));

    this.subs.sink = this.repository.get<ContactListContactModel>('api/Contact/AssignDetails?query=' + query + '&companyId=' + this.selectedCompany).subscribe(resp => {
      let contact = resp.data;
      let oldCustomFields: CustomFieldJson[] = contact.customFieldsJson;

      contact.customFieldsJson = this.updateCustomFields(this.contactListContacts.customFields, contact.customFieldsJson);

      this.editModal.show(contact, false, oldCustomFields);
    });
  }

  private delete(idContactContactList) {
    let contactId = this.contactListContacts.contacts.find(x => x.idContactContactList == idContactContactList).id;
    let rowObj = this.dtTable.GetItems('idcontactcontactlist', idContactContactList)[0];

    this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
      if (afResp.hasErrors) {
        Toast.Show(afResp.error, 'Delete contact', 'error');
      } else {
        this.msgDialog.show(
          "Are you sure you want to remove " + (rowObj.email ? rowObj.email : rowObj.phone) + "?",
          MessageType.YESNO,
          "Delete conformation!",
          () => {
            this.subs.sink = this.repository.del('api/Contact/Remove/' + contactId + '?companyId=' + this.selectedCompany, afResp.data).subscribe(resp => {
              if (resp.hasErrors) {
                Toast.Show(resp.error, 'Delete contact', 'error');
              } else {
                Toast.Show('Contact successfully deleted.', 'Delete contact', 'success');
              }

              let rowIndex = this.dtTable.GetRowIndexes('idcontactcontactlist', idContactContactList);
              this.dtTable.DeleteRow(rowIndex[0]);
            });
          });
      }
    });
  }

  private deleteList() {
    let that = this;

    let checked: number[] = this.dtTable._dataTable.rows('.selected').data().toArray().map(x => x.idcontactcontactlist);
    let checkedContacts: number[] = this.dtTable._dataTable.rows('.selected').data().toArray().map((x: ContactListContact) => {
      return x.id * 1; //parseInt
    });

    if (checked.length == 0) {
      this.msgDialog.show("You must select contact!", MessageType.OK, "Delete conformation");
    } else {
      this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
        if (afResp.hasErrors) {
          Toast.Show(afResp.error, 'Delete contact(s)', 'error');
        } else {
          this.msgDialog.show("Are you sure you want to remove this " + checked.length + " item(s)?", MessageType.YESNO, "Delete conformation!", () => {
            this.subs.sink = this.repository.post<number[]>('api/Contact/ListRemove?companyId=' + this.selectedCompany, checkedContacts, afResp.data).subscribe(resp => {

              if (resp.hasErrors) {
                Toast.Show(resp.error, 'Delete contact(s)', 'error');
              } else {
                Toast.Show('Contact(s) successfully deleted.', 'Delete contact(s)', 'success');
              }

              checked.forEach(function (selected) {
                let contactIndex = that.contactListContacts.contacts.map(function (item) { return item.idContactContactList }).indexOf(Number(selected));
                let contact: ContactListContact = that.contactListContacts.contacts[contactIndex];
                let rowIndex = that.dtTable.GetRowIndexes('id', contact.id);
                that.dtTable.DeleteRow(rowIndex[0]);
              });
            });
          });
        }
      });
    }
  }

  private unsubscribe(idContactContactList) {
    let contact = this.contactListContacts.contacts.find(x => x.idContactContactList == idContactContactList);

    if (contact) {
      this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
        if (afResp.hasErrors) {
          Toast.Show(afResp.error, 'Unsubscribe contact', 'error');
        } else {
          this.msgDialog.show(
            "Are you sure you want to unsubscribe " + (contact.email ? contact.email : contact.phone) + " from " + this.contactListContacts.name + "?",
            MessageType.YESNO,
            "Unsubscribe conformation!",
            () => {
              this.subs.sink = this.repository.del('api/Contact/Unassign/' + idContactContactList, afResp.data).subscribe(resp => {
                if (resp.hasErrors) {
                  Toast.Show(resp.error, 'Unsubscribe contact', 'error');
                } else {
                  Toast.Show('Contact successfully unsubscribed.', 'Unsubscribe contact', 'success');
                }

                let rowIndex = this.dtTable.GetRowIndexes('idcontactcontactlist', idContactContactList);
                this.dtTable.DeleteRow(rowIndex[0]);
              });
            });
        }
      });
    }

  }

  private listUnsubscribe() {
    let that = this;

    let checked: number[] = this.dtTable._dataTable.rows('.selected').data().toArray().map(x => x.idcontactcontactlist);

    if (checked.length == 0) {
      this.msgDialog.show("You must select contact!", MessageType.OK, "Unsubscribe conformation");
    } else {
      this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
        if (afResp.hasErrors) {
          Toast.Show(afResp.error, 'Delete contact(s)', 'error');
        } else {
          this.msgDialog.show("Are you sure you want to unsubscribe this " + checked.length + " item(s)?", MessageType.YESNO, "Unsubscribe conformation!", () => {
            this.subs.sink = this.repository.post<number[]>('api/Contact/ListUnassign', checked, afResp.data).subscribe(resp => {

              if (resp.hasErrors) {
                Toast.Show(resp.error, 'Delete contact(s)', 'error');
              } else {
                Toast.Show('Contact(s) successfully deleted.', 'Delete contact(s)', 'success');
              }

              checked.forEach(function (selected) {
                let contactIndex = that.contactListContacts.contacts.map(function (item) { return item.idContactContactList }).indexOf(Number(selected));
                let contact: ContactListContact = that.contactListContacts.contacts[contactIndex];
                let rowIndex = that.dtTable.GetRowIndexes('id', contact.id);
                that.dtTable.DeleteRow(rowIndex[0]);
              });
            });
          });
        }
      });
    }

  }

  private viewUnsubscribesContacts() {
    this.router.navigate(['/unsubscribedcontacts', this.id]);
  }

  private onSaved(data: ContactListContactModel) {
    let contact = this.dtTable.GetItems('id', data.id)[0];
    let customFieldData: CustomFieldJson[] = [];

    data.customFieldsJson.forEach(function (item) {
      customFieldData.push(new CustomFieldJson(item.idCustomField, item.value, item.name, item.type, item.isRequired));
    });

    if (contact) {
      contact.email = data.email;
      contact.phone = data.phone;
      contact.customFieldsJson = customFieldData;

      let editedContact = {
        "idcontactcontactlist": contact.idcontactcontactlist,
        "id": contact.id,
        "email": contact.email,
        "phone": contact.phone
      }

      for (let i = 0; i < this.contactListContacts.customFields.length; i++) {
        editedContact[this.contactListContacts.customFields[i].name] = contact.customFieldsJson[i].value;
      }

      let rowIndex = this.dtTable.GetRowIndexes('id', contact.id);
      this.dtTable.UpdateRow(rowIndex[0], editedContact);

    } else {
      let newContact = new ContactListContact(
        data.idContactContactList,
        data.id,
        data.email,
        data.phone,
        customFieldData
      );

      let createdContact = {
        "idcontactcontactlist": newContact.idContactContactList,
        "id": newContact.id,
        "email": newContact.email,
        "phone": newContact.phone
      }

      for (let i = 0; i < this.contactListContacts.customFields.length; i++) {
        createdContact[this.contactListContacts.customFields[i].name] = newContact.customFieldsJson[i].value;
      }

      this.dtTable.AddRow(createdContact);
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();

    if (this.dtTable) {
      this.dtTable.Destroy();
      this.dtTable = null;
    }

    if (this.selectCompanyHtmlElement.hasClass('disabled')) {
      this.selectCompanyHtmlElement.removeClass('disabled');
    }
  }

  private updateCustomFields(contactListCustomFields: CustomFieldJson[], contactCustomField: CustomFieldJson[]) {
    let updatedData: CustomFieldJson[] = []

    contactListCustomFields.forEach(function (clcf) {
      let contact = contactCustomField.find(x => x.idCustomField == clcf.idCustomField);

      if (!contact) {
        updatedData.push(clcf);
      }

      contactCustomField.forEach(function (ccf) {
        if (ccf.idCustomField == clcf.idCustomField)
          updatedData.push(ccf);
      });

    });

    return updatedData;
  }
}

export class Unsubscribe {
  idContact: number;
  idContactList: number

  constructor(idContact: number, idContactList: number) {
    this.idContact = idContact;
    this.idContactList = idContactList;
  }
}


